import { render, staticRenderFns } from "./Navmenu.vue?vue&type=template&id=1063c9c2&scoped=true&"
import script from "./Navmenu.vue?vue&type=script&lang=js&"
export * from "./Navmenu.vue?vue&type=script&lang=js&"
import style0 from "./Navmenu.vue?vue&type=style&index=0&id=1063c9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1063c9c2",
  null
  
)

export default component.exports